function getTableSearchParams(identifier) {
  return state => state.uiElements.tables[identifier].searchParams;
}

export { getTableSearchParams };
